import React, { useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import Close from '../Assets/close.svg';
import Navbar from '../components/Navbar';
import { Link, useLocation, useHistory } from 'react-router-dom';
import './VerifyMail.styles.scss';
import GreenCheck from '../Assets/green-check.svg';
import MailSent from '../Assets/mail-sent.svg';
import ForwardArrow from '../Assets/forward-arrow.svg';
import { hideLoader, showLoader } from '../util/loader/CustomLoader';
import DevAuthAPI from '../api/DevAuth';
import { CustomToast } from '../util/custom-toast/CustomToast';
import { migrateToBUBasedDC } from '../util/helpers/funcHelper';

const MailVerified = () => {
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const success = query.get('success');
    
    const params = location.search+location.hash;

    if(success && success==="false"){
        history.push({
        pathname:'/mail-expired',
        search: params,
    })
    }
    const email = query.get('email');
    const [attempt, setAttempt] = useState(1);
    const sendVerifyLink = () => {
        showLoader(); 
        setAttempt(attempt + 1);
        var api = new DevAuthAPI();
        //API doesn't exist for resend signup verification email
        //To be changed to api.<function_name>
        if (attempt < 3) {
            api.resendVerificationEmail({ email: email })
                .then((response) => {
                    hideLoader();
                    // setAttempt(attempt + 1);

                    CustomToast(
                        `Please check your email to verify signup : Attempt ${attempt + 1
                        }`)

                })
                .catch((error) => {
                    hideLoader();
                    CustomToast(error.response.data.message);
                });
        }
        else {
            CustomToast(
                `Resend Email Verification maximum
                attempts reached, please try after 5
                mins.`);
                setTimeout(()=>setAttempt(1),300000);
            hideLoader();
        }
    };

    return (
        <React.Fragment>
            <Navbar showSignup={false} />
            <Container fluid className="main-container">
                {location.pathname === '/mail-verified' ? (
                    <Modal
                        show={true}
                        centered
                        contentClassName="mail-modal p-2"
                    >
                        <Link to="/" style={{ marginLeft: '95%' }}>
                            <img
                                src={Close}
                                height="14"
                                width="14"
                                alt="cross"
                            />
                        </Link>
                        <Modal.Body>
                            <Container className="text-center col-xs-1">
                                <img
                                    alt="mail-verified"
                                    src={GreenCheck}
                                    height="25"
                                />
                                <h4 className="mt-2">Thank you!</h4>
                                <p className="mt-4">
                                    You have successfully registered your
                                    account,
                                </p>
                                <p>please click below to sign in </p>

                                <Link to="/login" replace="true">
                                    <p className="link">
                                        Sign In{' '}
                                        <img
                                            alt="login"
                                            src={ForwardArrow}
                                            height="12"
                                            width="13"
                                            style={{ marginTop: -2 }}
                                        />
                                    </p>
                                </Link>
                            </Container>
                        </Modal.Body>
                    </Modal>
                ) : (
                    <Modal
                        show={true}
                        centered
                        contentClassName="mail-modal p-2"
                    >
                        <Link to="/" style={{ marginLeft: '95%' }}>
                            <img
                                src={Close}
                                height="14"
                                width="14"
                                alt="cross"
                            />
                        </Link>
                        <Modal.Body>
                            <Container className="text-center col-xs-1">

                                    <>
                                        <img
                                            alt="mail-sent"
                                            src={MailSent}
                                            height="25"
                                        />
                                        <h4 className="mt-2">Check your mail</h4>
                                        <p className="mt-4">
                                            A confirmation link has been sent to
                                            your registered email.
                                        </p>
                                        <p>
                                            Click on the link in the mail and
                                            Sign In to proceed with your
                                            registration.
                                        </p>
                                        <div className="d-flex d-justify-evenly">
                                            <div
                                                className="link"
                                                id="disableResend"
                                                onClick={() => sendVerifyLink()
                                                }
                                            >
                                                Didn't receive mail? Resend
                                            </div>
                                            <div
                                                className="link"
                                                onClick={() => history.push("/login")
                                                }
                                            >
                                                Sign In{' '}
                                            </div>
                                        </div>
                                    </>
                                
                            </Container>
                        </Modal.Body>
                    </Modal>
                )}
            </Container>
        </React.Fragment>
    );
};

export default MailVerified;
